import {exhaustiveCheck} from 'web-app/util/typescript';

import {
    type ParentDocumentForChildProfileFromRest,
    type ParentDocumentForChildProfileForApollo,
    type AcknowledgementState,
} from './parent-document-for-child-profile';

const setStatus = (document: ParentDocumentForChildProfileFromRest): AcknowledgementState => {
    if (!document.requiresAcknowledgement) {
        return 'not-required';
    }

    switch (document.reply.answer) {
        case 1:
            return 'acknowledged';
        case 0:
            return 'pending';
        default:
            exhaustiveCheck(document.reply.answer);
            return 'not-required';
    }
};

export const parentDocumentForChildProfileTypePatcher = (
    data: ParentDocumentForChildProfileFromRest,
): ParentDocumentForChildProfileForApollo => {
    return {
        __typename: 'ParentDocumentForChildProfile',
        ...data,
        documentId: data.permissionId,
        acknowledgementStatus: setStatus(data),
        documentReplyId: data.reply.permissionReplyId,
    };
};
